// extracted by mini-css-extract-plugin
module.exports = {"container":"_7345603c"};